/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetExamTypeForChannelDto } from './GetExamTypeForChannelDto';
import {
    GetExamTypeForChannelDtoFromJSON,
    GetExamTypeForChannelDtoFromJSONTyped,
    GetExamTypeForChannelDtoToJSON,
} from './GetExamTypeForChannelDto';
import type { GetHealthcareFacilityDto } from './GetHealthcareFacilityDto';
import {
    GetHealthcareFacilityDtoFromJSON,
    GetHealthcareFacilityDtoFromJSONTyped,
    GetHealthcareFacilityDtoToJSON,
} from './GetHealthcareFacilityDto';

/**
 * 
 * @export
 * @interface GetAppointmentChannelDto
 */
export interface GetAppointmentChannelDto {
    /**
     * 
     * @type {string}
     * @memberof GetAppointmentChannelDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetAppointmentChannelDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAppointmentChannelDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAppointmentChannelDto
     */
    timeWindow?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetAppointmentChannelDto
     */
    channelPublic?: boolean;
    /**
     * 
     * @type {GetHealthcareFacilityDto}
     * @memberof GetAppointmentChannelDto
     */
    healthcareFacility?: GetHealthcareFacilityDto | null;
    /**
     * 
     * @type {Array<GetExamTypeForChannelDto>}
     * @memberof GetAppointmentChannelDto
     */
    examTypesForChannels?: Array<GetExamTypeForChannelDto> | null;
}

/**
 * Check if a given object implements the GetAppointmentChannelDto interface.
 */
export function instanceOfGetAppointmentChannelDto(value: object): value is GetAppointmentChannelDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function GetAppointmentChannelDtoFromJSON(json: any): GetAppointmentChannelDto {
    return GetAppointmentChannelDtoFromJSONTyped(json, false);
}

export function GetAppointmentChannelDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAppointmentChannelDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'timeWindow': json['timeWindow'] == null ? undefined : json['timeWindow'],
        'channelPublic': json['channelPublic'] == null ? undefined : json['channelPublic'],
        'healthcareFacility': json['healthcareFacility'] == null ? undefined : GetHealthcareFacilityDtoFromJSON(json['healthcareFacility']),
        'examTypesForChannels': json['examTypesForChannels'] == null ? undefined : ((json['examTypesForChannels'] as Array<any>).map(GetExamTypeForChannelDtoFromJSON)),
    };
}

export function GetAppointmentChannelDtoToJSON(value?: GetAppointmentChannelDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
        'timeWindow': value['timeWindow'],
        'channelPublic': value['channelPublic'],
        'healthcareFacility': GetHealthcareFacilityDtoToJSON(value['healthcareFacility']),
        'examTypesForChannels': value['examTypesForChannels'] == null ? undefined : ((value['examTypesForChannels'] as Array<any>).map(GetExamTypeForChannelDtoToJSON)),
    };
}

